import React from 'react';

const IconlyCurvedBoldChat = ({ width = 20, height = 20, fill = "#D9D9D9" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 20 20">
    <path
      fill={fill}
      fillRule="evenodd"
      d="M13.291 11.18a.837.837 0 0 1-.837-.833.83.83 0 0 1 .83-.834h.007a.833.833 0 1 1 0 1.667Zm-3.34 0a.836.836 0 0 1-.838-.833.83.83 0 0 1 .83-.834h.008a.833.833 0 1 1 0 1.667Zm-3.341 0a.836.836 0 0 1-.837-.833.83.83 0 0 1 .83-.834h.007a.833.833 0 1 1 0 1.667Zm9.578-7.367a8.692 8.692 0 0 0-6.186-2.56c-2.339 0-4.536.91-6.187 2.56C1.23 6.4.525 10.367 2.045 13.646c.028.135-.046.684-.1 1.086-.201 1.505-.304 2.61.206 3.121.51.511 1.615.408 3.12.205.401-.053.957-.125 1.044-.116a8.72 8.72 0 0 0 3.667.805 8.775 8.775 0 0 0 6.206-2.558c3.411-3.412 3.412-8.964 0-12.376Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IconlyCurvedBoldChat;